<template>
  <div class="privacy-page heavy-rain-gradient">
    <PrivacyHeader />
    <PrivacyContent />
  </div>
</template>

<script>
import PrivacyHeader from '../sections/privacy/PrivacyHeader.vue'
import PrivacyContent from '../sections/privacy/PrivacyContent.vue'

export default {
  name: 'Privacy',
  components: {
    PrivacyHeader,
    PrivacyContent
  }
}
</script>

<style scoped>
.privacy-page {
  padding-top: 80px;
  min-height: 100vh;
}
</style>

